export default "__VITE_ASSET__B$GoHTZT__"